// Helper für API Calls
export const fetchBlockHeight = async () => {
  try {
    const response = await fetch('https://mempool.space/api/blocks/tip/height');
    if (!response.ok) throw new Error('Network response was not ok');
    const height = await response.text();
    return parseInt(height, 10);
  } catch (error) {
    console.error("Error fetching block height:", error);
    return null;
  }
};

export const fetchLatestBlock = async () => {
  try {
    const response = await fetch('https://mempool.space/api/blocks');
    if (!response.ok) throw new Error('Network response was not ok');
    const blocks = await response.json();
    const latestBlock = blocks[0];
    if (latestBlock && latestBlock.timestamp) {
      latestBlock.timestamp = parseInt(latestBlock.timestamp, 10);
    }
    return latestBlock;
  } catch (error) {
    console.error("Error fetching latest block:", error);
    return null;
  }
};

export const fetchBitcoinPrice = async () => {
  try {
    // Use blockchain.com API for prices
    const response = await fetch('https://blockchain.info/ticker');
    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    
    console.log('Blockchain.com API Response:', data);
    
    // The blockchain.com API returns data like:
    // {
    //   "USD": {
    //     "symbol": "$",
    //     "15m": 42123.45,
    //     "last": 42123.45,
    //     "buy": 42124.56,
    //     "sell": 42122.34,
    //     "timestamp": 1234567890
    //   },
    //   "EUR": {
    //     "symbol": "€",
    //     "15m": 38456.78,
    //     "last": 38456.78,
    //     "buy": 38457.89,
    //     "sell": 38455.67,
    //     "timestamp": 1234567890
    //   }
    // }
    
    // Convert to our format for compatibility with rounded values
    const parsedRates = {};
    if (data) {
      Object.keys(data).forEach(currency => {
        parsedRates[currency] = {
          code: currency,
          symbol: data[currency].symbol,
          rate: Math.round(data[currency].last).toLocaleString('en-US'), // Rounded value
          description: currency === 'USD' ? 'United States Dollar' : 'Euro',
          rate_float: Math.round(data[currency].last) // Rounded float value
        };
      });
    }
    
    console.log('Parsed rates for blockchain.com (rounded):', parsedRates);
    return parsedRates;
  } catch (error) {
    console.error("Error fetching price:", error);
    return null;
  }
};

export const fetchFees = async () => {
  try {
    const response = await fetch('https://mempool.space/api/v1/fees/recommended');
    if (!response.ok) throw new Error('Network response was not ok');
    return await response.json();
  } catch (error) {
    console.error("Error fetching fees:", error);
    return null;
  }
};

export const fetchNetworkStats = async () => {
  try {
    console.log('Fetching blockchain.info stats API...');
    // Use blockchain.info API for hashrate and difficulty
    const response = await fetch('https://api.blockchain.info/stats');
    if (!response.ok) throw new Error('Network response was not ok');
    const stats = await response.json();
    
    console.log('Blockchain.info Stats API Response:', JSON.stringify(stats, null, 2));
    
    // The blockchain.info API returns:
    // {
    //   "market_price_usd": 42123.45,
    //   "hash_rate": 4322123456789000,
    //   "total_fees_btc": 1234.56,
    //   "n_btc_mined": 6.25,
    //   "n_tx": 3000000,
    //   "mempool_size": 50000,
    //   "difficulty": 71234567890123.45,
    //   "minutes_between_blocks": 10,
    //   "n_blocks_total": 850000,
    //   "blocks_mined_24h": 144,
    //   "estimated_btc_sent_24h": 2500.5,
    //   "estimated_transaction_volume_usd": 105000000,
    //   "estimated_transaction_volume_btc": 2500.5
    // }
    
    // Hashrate is already in H/s as a number
    let hashrateValue = 0;
    if (stats.hash_rate) {
      hashrateValue = parseFloat(stats.hash_rate);
      console.log('Parsed hashrate from blockchain.info:', hashrateValue);
      console.log('Hashrate type:', typeof hashrateValue);
      console.log('Hashrate is NaN?', isNaN(hashrateValue));
    } else {
      console.log('No hash_rate field found in blockchain.info response');
    }
    
    // Difficulty is already a number
    let difficultyValue = 0;
    if (stats.difficulty) {
      difficultyValue = parseFloat(stats.difficulty);
      console.log('Parsed difficulty from blockchain.info:', difficultyValue);
      console.log('Difficulty type:', typeof difficultyValue);
      console.log('Difficulty is NaN?', isNaN(difficultyValue));
    } else {
      console.log('No difficulty field found in blockchain.info response');
    }
    
    // Check available fields
    console.log('Available fields in blockchain.info response:', Object.keys(stats));
    
    return {
      current_hashrate: hashrateValue,
      current_difficulty: difficultyValue,
      _raw: stats
    };
  } catch (error) {
    console.error("Error fetching network stats:", error);
    return null;
  }
};